import { Component } from '@angular/core';

@Component({
  selector: 'app-signed-out',
  templateUrl: './signed-out.component.html',
  styleUrls: ['./signed-out.component.scss'],
})
export class SignedOutComponent {}
